import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CATEGORIES } from "@/data/products";
import { useProducts } from "@/context/ProductsContext";
import { PageHead } from "@/components/site/PageHead";
import { ProductCard } from "@/components/site/ProductCard";
import { ContactBand } from "@/components/site/ContactBand";

export default function Products() {
  const { products: PRODUCTS } = useProducts();
  const [cat, setCat] = useState("All");
  const list = cat === "All" ? PRODUCTS : PRODUCTS.filter((p) => p.category === cat);

  return (
    <div data-testid="products-page">
      <PageHead eyebrow={`Catalogue · ${PRODUCTS.length} products`} lines={["The ink", <span key="c" className="text-[#FF5A00]">catalogue.</span>]}>
        <p className="mt-8 max-w-xl text-base text-zinc-700 md:text-lg">Every product is supplied from 100 kg, with bulk quantities at reasonable prices.</p>
      </PageHead>
      <div className="sticky top-[72px] z-30 border-y border-black/10 bg-[#FAFAF7]/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-[1440px] gap-2 overflow-x-auto px-5 py-4 md:px-10">
          {CATEGORIES.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
              className={`relative shrink-0 px-4 py-2.5 font-mono text-xs uppercase tracking-[0.15em] transition-colors duration-300 ${cat === c ? "text-white" : "text-zinc-700 hover:text-[#0B0B0B]"}`}>
              {cat === c && <motion.span layoutId="chip" className="absolute inset-0 bg-[#0B0B0B]" transition={{ type: "spring", stiffness: 380, damping: 32 }} />}
              <span className="relative">{c}</span>
            </button>
          ))}
        </div>
      </div>
      <section className="mx-auto max-w-[1440px] px-5 py-16 md:px-10 md:py-24">
        <p data-testid="product-count" className="mb-10 font-mono text-xs uppercase tracking-[0.2em] text-zinc-700">Showing {list.length} of {PRODUCTS.length}</p>
        <motion.div layout className="grid grid-cols-1 gap-x-6 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
          <AnimatePresence>
            {list.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
          </AnimatePresence>
        </motion.div>
      </section>
      <ContactBand />
    </div>
  );
}
